import { createSlice } from "@reduxjs/toolkit";
import { inbox_mails } from "../../../../types/mail/email";

export const inboxes = createSlice({
  name: "inboxes",
  initialState: {
    value: {
      status: false,
      pagination: [] as {
        pagination_data: {
          current_page: number;
          last_page: number;
          per_page: number;
          total: number;
          from: number;
          to: number;
        };
        data: inbox_mails;
      }[],
      data: [] as inbox_mails,
    },
  },
  reducers: {
    update_inboxes: (state, action) => {
      state.value.status = true;
      state.value.data = action?.payload;
    },
    add_inbox: (state, action) => {
      state.value.data = [...state.value.data, action?.payload];
    },
    remove_inbox: (state, action) => {
      const { id } = action?.payload;
      const currentArray = [...state.value.data];
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => Number(v.id) === id
      );
      currentArray.splice(currentIndex, 1);
      state.value.data = currentArray;
    },
    addToPaginationHistory: (state, action) => {
      state.value.pagination = [
        ...state.value.pagination,
        {
          pagination_data: action?.payload?.pagination_data,
          data: action?.payload?.data,
        },
      ];
    },
    replace_inbox: (state, action) => {
      const { id } = action?.payload;
      const currentArray = state.value.data;
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => v.id === id
      );
      currentArray.splice(currentIndex, 1, action?.payload);
      state.value.data = currentArray;
    },
    clear_inboxes: (state) => {
      state.value.status = false;
      state.value.data = [];
    },
  },
});

export const {
  update_inboxes,
  add_inbox,
  addToPaginationHistory,
  remove_inbox,
  replace_inbox,
  clear_inboxes,
} = inboxes.actions;

export default inboxes.reducer;
